import React, { Component } from "react";
import GoogleMapReact from "google-map-react";

const AnyReactComponent = ({ text }) => (
  <div
    style={{
      color: "white",
      background: "grey",
      padding: "15px 10px",
      display: "inline-flex",
      textAlign: "center",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "100%",
      transform: "translate(-50%, -50%)",
    }}
  >
    {text}
  </div>
);

class Map extends Component {
  static defaultProps = {
    center: {
      lat: 42.1601,
      lng: -71.0589,
    },
    zoom: 10,
  };

  render() {
    return (
      // Important! Always set the container height explicitly

      <div style={{ height: "100vh", width: "100%" }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: "AIzaSyAqOYmpbpID7PtOCK_HnTsGyI7xclKCchA" }}
          defaultCenter={this.props.center}
          defaultZoom={this.props.zoom}
        >
          <AnyReactComponent lat={18.951174} lng={-69.751889} text={"Ministry"} />
        </GoogleMapReact>
      </div>
    );
  }
}

export default Map;
